import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { ConfirmationModal, useOverlayContext } from 'seagull';
import { handlePromise } from '~/infra/utils';
export default function VendorAccountantAccessModal(props) {
    const { failureToastProps, onSuccess, onSubmit, dismissModal } = props, rest = _object_without_properties(props, [
        "failureToastProps",
        "onSuccess",
        "onSubmit",
        "dismissModal"
    ]);
    const overlayContext = useOverlayContext();
    const [loading, setLoading] = useState(false);
    async function onPrimaryButtonClick() {
        setLoading(true);
        const { success } = await handlePromise(onSubmit());
        if (success) {
            await onSuccess();
        } else if (failureToastProps) {
            overlayContext.showErrorToast(failureToastProps.text, failureToastProps.testId);
        }
        setLoading(false);
        dismissModal();
    }
    return /*#__PURE__*/ _jsx(ConfirmationModal, _object_spread({
        textAlignCenter: false,
        secondaryButtonLabel: "Cancel",
        onCloseButtonClick: dismissModal,
        onSecondaryButtonClick: dismissModal,
        onPrimaryButtonClick: onPrimaryButtonClick,
        primaryButtonLoading: loading
    }, rest));
}
